import { FC, ReactElement, ReactNode } from 'react'

interface CaseProps {
  children?: ReactNode
  when: string | number
}

interface DefaultProps {
  children?: ReactNode
  when?: never
}

interface MatchComponentProps {
  condition: undefined | string | number
  children?:
    | ReactElement<CaseProps | DefaultProps>
    | ReactElement<CaseProps | DefaultProps>[]
}

interface MatchComponentType extends FC<MatchComponentProps> {
  Case: FC<CaseProps>
  Default: FC<DefaultProps>
}

export const Match: MatchComponentType = ({ condition, children }) => {
  if (!children) {
    return null
  }

  const arrayOfChildren = Array.isArray(children) ? children : [children]
  const cases = arrayOfChildren.filter(
    // @ts-ignore
    (child) => child.props.when === condition,
  )
  // @ts-ignore
  const defaultCases = arrayOfChildren.filter((child) => !child.props.when)
  if (defaultCases.length > 1) {
    throw new Error('Only one <Match.Default> is allowed')
  }
  const defaultCase = defaultCases[0]

  return cases.length > 0 ? <>{cases}</> : <>{defaultCase}</>
}

Match.Case = ({ children }) => {
  return <>{children}</>
}

Match.Default = ({ children }) => {
  return <>{children}</>
}
